import { render, staticRenderFns } from "./MarkingList.vue?vue&type=template&id=265b19f1&scoped=true"
import script from "./MarkingList.vue?vue&type=script&lang=js"
export * from "./MarkingList.vue?vue&type=script&lang=js"
import style0 from "./MarkingList.vue?vue&type=style&index=0&id=265b19f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265b19f1",
  null
  
)

export default component.exports